/**
 * @module FE-CU29_通知配信設定画面_カメラ
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import NormalButton from '../../../components/button/Normal.vue';
import CheckList from '../../../components/checkList/Index.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import MobileFooter from '@/components/footer/MobileFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU29';

export default {
  name: 'CameraNotificationSetting',
  components: {
    Header,
    BreadCrumbList,
    ListPanel,
    NormalButton,
    CheckList,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU29通知配信設定画面カメラ.通知配信設定'),
      panelTitle: {
        place: ``,
        type: '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.カメラ詳細',
        typeIsBefore: false,
      },
      cameraList: [],
      pushFlag: null,
      pushItems: [
        {
          id: 1,
          name: '$vuetify.FECU29通知配信設定画面カメラ.動体検知_ローバッテリー',
          flag: false,
          error: '',
        },
      ],
      mailFlag: null,
      mailItems: [
        {
          id: 1,
          name: '$vuetify.FECU29通知配信設定画面カメラ.動体検知_ローバッテリー',
          flag: false,
          error: '',
        },
      ],

      isDisabledSettingBtn: true,
      isDisabledForPush: false,
      isDisabledForEmail: false,
      dialog: false,
      pushError: {
        flag: false,
        message: '$vuetify.メッセージ一覧.FECU29通知配信設定画面カメラ.E0002',
      },
      mailError: {
        flag: false,
        message: '$vuetify.メッセージ一覧.FECU29通知配信設定画面カメラ.E0003',
      },
      modified: '',
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU29通知配信設定画面カメラ.通知配信設定'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU29通知配信設定画面カメラ.C0001'),
        pushTitle: vm.$vuetify.lang.t('$vuetify.FECU29通知配信設定画面カメラ.通知内容選択'),
        mailTitle: vm.$vuetify.lang.t('$vuetify.FECU29通知配信設定画面カメラ.通知内容選択'),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * PUSH通知の全て選択ボタン押下時処理
     */
    onPushAllClick: function () {
      this.pushItems.forEach(function (item) {
        item.flag = true;
      });
      this.checkValid();
    },
    /**
     * PUSH通知のクリアボタン押下時処理
     */
    onPushClearClick: function () {
      this.pushItems.forEach(function (item) {
        item.flag = false;
      });
      this.checkValid();
    },
    /**
     * Eメール通知の全て選択ボタン押下時処理
     */
    onMailAllClick: function () {
      this.mailItems.forEach(function (item) {
        item.flag = true;
      });
      this.checkValid();
    },
    /**
     * Eメール通知のクリアボタン押下時処理
     */
    onMailClearClick: function () {
      this.mailItems.forEach(function (item) {
        item.flag = false;
      });
      this.checkValid();
    },
    /**
     * ラジオボタン、チェックボックの状態をチェックして
     * 設定ボタンの活性制御を行う
     */
    checkValid: function () {
      if (this.pushFlag === true && this.mailFlag === true) {
        // PUSH通知・Eメール通知の両方が「通知する」の場合、両方のチェック状態確認
        this.checkPushCheckbox();
        this.checkMailCheckbox();
      } else if (this.pushFlag === true && this.mailFlag === false) {
        // PUSH通知が「通知する」、Eメール通知が「通知しない」の場合、PUSH通知のチェック状態確認
        this.checkPushCheckbox();
        this.mailError.flag = false;
      } else if (this.pushFlag === false && this.mailFlag === true) {
        // PUSH通知が「通知しない」、Eメール通知が「通知する」の場合、Eメール通知のチェック状態確認
        this.checkMailCheckbox();
        this.pushError.flag = false;
      } else {
        // PUSH通知・Eメール通知の両方が「通知しない」の場合、チェック状態確認なし
        this.pushError.flag = false;
        this.mailError.flag = false;
      }

      //「通知しない」場合チェックを外す
      if (!this.pushFlag) {
        this.pushItems.forEach(function (item) {
          item.flag = false;
        });
      }
      if (!this.mailFlag) {
        this.mailItems.forEach(function (item) {
          item.flag = false;
        });
      }

      // 設定ボタンの活性判定
      this.isDisabledSettingBtn =
        this.pushError.flag === false && this.mailError.flag === false ? false : true;
    },
    /**
     * PUSH通知のチェックボックス状態確認
     */
    checkPushCheckbox: function () {
      for (let i = 0; i < this.pushItems.length; i++) {
        if (this.pushItems[i].flag === true) {
          this.pushError.flag = false;
          break;
        }
        this.pushError.flag = true;
      }
    },
    /**
     * Eメール通知のチェックボックス状態確認
     */
    checkMailCheckbox: function () {
      // Eメール通知のチェックボックス状態確認
      for (let i = 0; i < this.mailItems.length; i++) {
        if (this.mailItems[i].flag === true) {
          this.mailError.flag = false;
          break;
        }
        this.mailError.flag = true;
      }
    },
    /**
     * 通知配信設定データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2901: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     pushNotificationDeliveryInfo: {
            //       isNotification: true,
            //       isMotionSensingNotification: true,
            //     },
            //     mailNotificationDeliveryInfo: {
            //       isNotification: true,
            //       isMotionSensingNotification: true,
            //     },
            //     modified: "2022-05-02 18:00:00",
            //   },
            // };

            this.modified = apiData.contentsInfo.modified;

            // 取得したデータをマッピングする
            this.pushItems[0].flag =
              apiData.contentsInfo.pushNotificationDeliveryInfo.isMotionSensingNotification;
            this.mailItems[0].flag =
              apiData.contentsInfo.mailNotificationDeliveryInfo.isMotionSensingNotification;

            this.pushFlag = apiData.contentsInfo.pushNotificationDeliveryInfo.isNotification;
            this.mailFlag = apiData.contentsInfo.mailNotificationDeliveryInfo.isNotification;

            const targetItem = apiData.contentsInfo.cameraInfo;
            const labels = {
              usagePlan: '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.ニックネーム地区表示',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };

            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '') {
                    return;
                  }
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU29通知配信設定画面カメラ.メイン地区';
                  }
                }

                if (text) {
                  this.cameraList = [
                    ...this.cameraList,
                    {
                      id: index,
                      title: labels[key],
                      text: text,
                      isVuetifyKey: text.includes('$'),
                    },
                  ];
                }
              }
            });
            this.panelTitle = {
              place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName}`,
              type: '$vuetify.FECU29通知配信設定画面カメラ.カメラ詳細表示領域.カメラ詳細',
              typeIsBefore: true,
            };
          },
          (error) => {
            // レスポンスステータス403の場合、トップページへリダイレクト
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      this.checkValid();
      return apiData;
    },
    /**
     * 通知配信設定データ更新API実行処理
     */
    APP_CU2902: function () {
      this.$_setLoading(true);

      let param = '/api/cameraNotificationDeliverySetting/update';
      // let param = "post";
      let method = 'post';

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        pushNotificationDeliveryInfo: {
          isNotification: this.pushFlag == true ? true : false,
          isMotionSensingNotification: this.pushItems[0].flag,
        },
        mailNotificationDeliveryInfo: {
          isNotification: this.mailFlag == true ? true : false,
          isMotionSensingNotification: this.mailItems[0].flag,
        },
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            this.$informationDialog(
              '$vuetify.メッセージ一覧.FECU29通知配信設定画面カメラ.C0003',
              false,
              true
            );
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU29通知配信設定画面カメラ.E0001');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return;
    },
    /**
     * 設定ボタン押下時処理
     * 確認ダイアログを表示して通知配信設定データ更新APIを実行
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU29通知配信設定画面カメラ.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.APP_CU2902();
      }
    },
    /**
     * ラベル項目の幅変更処理
     * @param {*} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    let param = '/api/cameraNotificationDeliverySetting/init';
    // let param = "post";

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      deviceID: this.$store.state.deviceID,
    };

    let method = 'post';
    // APP_CU2901
    await this.APP_CU2901(param, queries, method);

    //警備ユニットと通信しない為、データが揃ってから表示
    this.isShowPage = true;
  },
};
